import { useDataSubmit, useDataValue } from 'Simple/Data.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'task',
  })

  return async function onClick() {
    submit({ type: 'generate_letter' })
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
